import React, { Component } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import Slider from './slider';
import './index.css';
import Postman from '../../utils/service';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { SET_FILTER } from '../../actions/actiontypes';
import queryString from 'query-string';

const extractFilterData = data => data.filter(item => item.DISTINCT)
  .map(item => ({ value: item.DISTINCT, label: item.DISTINCT }));

const searchBlock = {
  marginTop: 25
};

class Aside extends Component {
  constructor(props) {
    super(props);
    const pageNo = props.history.location.pathname.replace('/employee-search', '').replace('/search', '').replace('/', '');
    const parsed = queryString.parse(props.location.search);
  
    // Helper function to safely parse range values
    const parseRange = (minKey, maxKey, defaultMin, defaultMax) => {
      const min = parsed[minKey] ? Math.max(Number(parsed[minKey]), defaultMin) : defaultMin;
      const max = parsed[maxKey] ? Math.min(Number(parsed[maxKey]), defaultMax) : defaultMax;
      return min !== defaultMin || max !== defaultMax ? [min, max] : null;
    };
  
    this.state = {
      all: true,
      selectedIndustry: parsed.industry ? { value: parsed.industry, label: parsed.industry } : null,
      selectedCountry: parsed.country ? { value: parsed.country, label: parsed.country } : null,
      selectedCity: parsed.city ? { value: parsed.city, label: parsed.city } : null,
      selectedState: parsed.state ? { value: parsed.state, label: parsed.state } : null,
      selectedSubIndustry: null, // Not currently in URL params
      industryList: null,
      countryList: null,
      cityList: null,
      stateList: null,
      subIndustryList: null,
      loading: true,
      refresh: false,
      pageType: props.history.location.pathname === '/' ? 'home' : 'search',
      activeTab: props.history.location.pathname.includes('/employee-search') ? 'employees' : 'companies',
      selectedTitle: parsed.titles ? 
        parsed.titles.split(',').map(title => ({ value: title, label: title })) : 
        null,
      fieldsDisabled: pageNo === '' || pageNo === '1' ? false : true,
      // Slider ranges with proper initialization
      currentEmployeesRange: parseRange('employees_min', 'employees_max', 1, 500),
      employeeGrowthRange: parseRange('growth_min', 'growth_max', 0, 1000),
      fundingRange: parseRange('funding_min', 'funding_max', 0, 1000),
      initializedFromUrl: false 

    };

    this.initialUrlParams = parsed;

  }

  componentDidUpdate(prevProps) {
    // When filter data loads
    if (!prevProps.filterData && this.props.filterData) {
      this.applyInitialFilters();
    }
    
  }
  

  componentWillReceiveProps(nextProps) {
    const { country, industry, city, state, subIndustry } = nextProps.filterData || {};
    const pageNo = nextProps.history.location.pathname.replace('/employee-search', '').replace('/search', '').replace('/', '');
    
    const newState = {
      loading: false,
      countryList: extractFilterData(country),
      industryList: extractFilterData(industry),
      cityList: extractFilterData(city),
      stateList: extractFilterData(state),
      subIndustryList: extractFilterData(subIndustry),
      pageType: nextProps.history.location.pathname === '/' ? 'home' : 'search',
      activeTab: nextProps.history.location.pathname.includes('/employee-search') ? 'employees' : 'companies',
      fieldsDisabled: pageNo === '' || pageNo === '1' ? false : true
    };

    if(this.state.activeTab !== newState.activeTab) {
      this.resetAllFilters();
     
    }

    // Only update state if filterData exists
    if (nextProps.filterData) {
      this.setState(newState);
    }

    // Handle URL parameters
    const parsed = queryString.parse(nextProps.location.search);
    const urlState = {};
    
    if (parsed.industry && !this.state.selectedIndustry) {
      urlState.selectedIndustry = { value: parsed.industry, label: parsed.industry };
    }
    if (parsed.country && !this.state.selectedCountry) {
      urlState.selectedCountry = { value: parsed.country, label: parsed.country };
    }
    if (parsed.city && !this.state.selectedCity) {
      urlState.selectedCity = { value: parsed.city, label: parsed.city };
    }
    if (parsed.state && !this.state.selectedState) {
      urlState.selectedState = { value: parsed.state, label: parsed.state };
    }
    if (parsed.employee_title && !this.state.selectedTitle) {
      urlState.selectedTitle = parsed.employee_title.split(',').map(title => ({ value: title, label: title }));
    }

    if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }
  }

  applyInitialFilters = () => {
    const { initializedFromUrl } = this.state;
    const { filterData } = this.props;
    
    if (initializedFromUrl || !filterData) return;
  
    const filter = {};
    
    // Apply all URL parameters to Redux filter
    if (this.initialUrlParams.industry) {
      filter.industry = this.initialUrlParams.industry;
    }
    if (this.initialUrlParams.country) {
      filter.country = this.initialUrlParams.country;
    }
    // Add all other filters...
  
    // For array values (like titles)
    if (this.initialUrlParams.titles) {
      filter.employee_title = this.initialUrlParams.titles;
    }
  
    // For range values
    if (this.initialUrlParams.employees_min) {
      filter.current_employees = [
        Number(this.initialUrlParams.employees_min),
        Number(this.initialUrlParams.employees_max)
      ];
    }
    // Add other ranges...
  
    this.props.setFilter(filter);
    this.setState({ initializedFromUrl: true });
  };
  

  resetAllFilters = () => {
    this.setState({
      selectedIndustry: null,
      selectedCountry: null,
      selectedCity: null,
      selectedState: null,
      selectedSubIndustry: null,
      selectedTitle: null,
      currentEmployeesRange: null,
      employeeGrowthRange: null,
      fundingRange: null,
      refresh: true
    }, () => {
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: ''
      });
      this.props.setFilter({});
    });
  };

  updateURL = () => {
    const { history, location } = this.props;
    const { 
      selectedIndustry, 
      selectedCountry, 
      selectedCity, 
      selectedState,
      selectedTitle, 
      currentEmployeesRange,
      employeeGrowthRange,
      fundingRange
    } = this.state;
  
    const filterParams = {};
    
    if (selectedIndustry) filterParams.industry = selectedIndustry.value;
    if (selectedCountry) filterParams.country = selectedCountry.value;
    if (selectedCity) filterParams.city = selectedCity.value;
    if (selectedState) filterParams.state = selectedState.value;
    
    // Add employee titles to URL params
    if (selectedTitle && selectedTitle.length > 0) {
      filterParams.titles = selectedTitle.map(t => t.value).join(',');
    }
    
    // Add slider values to URL params
    if (currentEmployeesRange) {
      filterParams.employees_min = currentEmployeesRange[0];
      filterParams.employees_max = currentEmployeesRange[1];
    }
    if (employeeGrowthRange) {
      filterParams.growth_min = employeeGrowthRange[0];
      filterParams.growth_max = employeeGrowthRange[1];
    }
    if (fundingRange) {
      filterParams.funding_min = fundingRange[0];
      filterParams.funding_max = fundingRange[1];
    }
  
    history.push({
      pathname: location.pathname,
      search: queryString.stringify(filterParams)
    });
  };

  handleEmployeeChange = (value) => {
    if (typeof value === 'undefined') return;
    this.setState({ 
      currentEmployeesRange: value,
      all: false 
    }, () => {
      this.props.setFilter({ current_employees: value });
      this.updateURL();
    });
  };
  
  handleGrowthChange = (value) => {
    if (typeof value === 'undefined') return;
    this.setState({ 
      employeeGrowthRange: value,
      all: false 
    }, () => {
      this.props.setFilter({ employee_growth: value });
      this.updateURL();
    });
  };
  
  handleFundingChange = (value) => {
    if (typeof value === 'undefined') return;
    this.setState({ 
      fundingRange: value,
      all: false 
    }, () => {
      this.props.setFilter({ total_funding_float: value });
      this.updateURL();
    });
  };
  
  
  handleIndustryChange = (selectedIndustry) => {
    this.setState({ selectedIndustry, all: false }, () => {
      this.props.setFilter({ industry: selectedIndustry ? selectedIndustry.value : undefined });
      this.updateURL();
    });
  };
  
  // Similarly update all other handlers that use optional chaining:
  
  handleCountryChange = (selectedCountry) => {
    this.setState({ selectedCountry, all: false }, () => {
      this.props.setFilter({ country: selectedCountry ? selectedCountry.value : undefined });
      this.updateURL();
    });
  };
  
  handleCityChange = (selectedCity) => {
    this.setState({ selectedCity, all: false }, () => {
      this.props.setFilter({ city: selectedCity ? selectedCity.value : undefined });
      this.updateURL();
    });
  };
  
  handleStateChange = (selectedState) => {
    this.setState({ selectedState, all: false }, () => {
      this.props.setFilter({ state: selectedState ? selectedState.value : undefined });
      this.updateURL();
    });
  };
  
  handleSubIndustryChange = (selectedSubIndustry) => {
    this.setState({ selectedSubIndustry, all: false }, () => {
      this.props.setFilter({ subIndustry: selectedSubIndustry ? selectedSubIndustry.value : undefined });
      this.updateURL();
    });
  };
  

  handleEmployeeTitleChange = (selectedTitle) => {
    if (selectedTitle.length > 4) return;
    
    this.setState({ selectedTitle, all: false }, () => {
      const titles = selectedTitle.map(t => t.value).join(',');
      this.props.setFilter({ employee_title: titles });
      this.updateURL();
    });
  };


  changeRefresh = () => this.setState({ refresh: false });

  formatCreateLabel = (inputValue) => {
    return `Search For: "${inputValue}"`;
  };

  render() {
    const { loading } = this.state;
    if (loading) return null;

    return (
      <aside className="aside-menu-new" style={this.state.pageType == 'home' ? {} : { top: '25ch' }} >

        <h3>Filters</h3>
        <div style={searchBlock}>
          <div style={{ display: 'flex', marginBottom: 15 }}>
            {this.state.pageType === 'search' && (
              <span style={{ marginRight: 85, fontSize: 15 }}>
                <button 
                  onClick={this.resetAllFilters} 
                  style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer' }}
                >
                  Clear All <i className="fa fa-remove"></i>
                </button>
              </span>
            )}
          </div>

          {this.state.activeTab === 'employees' && (
            <div style={searchBlock}>
              <p>Employee title</p>
              <CreatableSelect
                value={this.state.selectedTitle}
                onChange={this.handleEmployeeTitleChange}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                isMulti
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                placeholder={'Type keywords, hit Enter'}
                isDisabled={this.state.fieldsDisabled}
                styles={{ height: 'auto' }}
                formatCreateLabel={this.formatCreateLabel}
              />
            </div>
          )}

          <div style={searchBlock}>
            <p>Current Employees</p>
            <Slider
              disabled={this.state.fieldsDisabled}
              onChange={this.handleEmployeeChange} 
              value={this.state.currentEmployeesRange}
              employees 
              minVal={1} 
              maxVal={500} 
              refresh={this.state.refresh} 
              changeRefresh={this.changeRefresh} 
            />
          </div>
          <div style={searchBlock}>
            <p>Employee Growth</p>
            <Slider
              disabled={this.state.fieldsDisabled} 
              onChange={this.handleGrowthChange} 
              value={this.state.employeeGrowthRange} 
              growth 
              minVal={0} 
              maxVal={1000} 
              refresh={this.state.refresh} 
              changeRefresh={this.changeRefresh} 
            />
          </div>
          <div style={searchBlock}>
            <p>Total Funding</p>
            <Slider
              disabled={this.state.fieldsDisabled} 
              onChange={this.handleFundingChange} 
              value={this.state.fundingRange}
              minVal={0} 
              maxVal={1000} 
              funding 
              refresh={this.state.refresh} 
              changeRefresh={this.changeRefresh} 
            />
          </div>
        </div>
        <div style={searchBlock}>
          <Select
            isDisabled={this.state.fieldsDisabled}
            value={this.state.selectedIndustry}
            onChange={this.handleIndustryChange}
            options={this.state.industryList}
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            placeholder={'Select Industry'}
          />
        </div>
        <div style={searchBlock}>
          <Select
            isDisabled={this.state.fieldsDisabled}
            value={this.state.selectedCountry}
            onChange={this.handleCountryChange}
            options={this.state.countryList}
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            placeholder={'Select Country'}
          />
        </div>
        <div style={searchBlock}>
          <Select
            isDisabled={this.state.fieldsDisabled}
            value={this.state.selectedCity}
            onChange={this.handleCityChange}
            options={this.state.cityList}
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            placeholder={'Select City'}
          />
        </div>
        <div style={searchBlock}>
          <Select
            isDisabled={this.state.fieldsDisabled}
            value={this.state.selectedState}
            onChange={this.handleStateChange}
            options={this.state.stateList}
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            placeholder={'Select State'}
          />
        </div>
      </aside>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setFilter: filter => dispatch({ type: SET_FILTER, payload: filter }),
});

export default withRouter(connect(null, mapDispatchToProps)(Aside));


// WEBPACK FOOTER //
// ./client/src/components/Aside/Aside.js